import { combineReducers } from 'redux';
import userFollows from './user-follows-reducer';
import pendingUserFollows from './pending-user-follows-reducer';

const followReducer = combineReducers({
  userFollows,
  pendingUserFollows,
});

export default followReducer;
